import React from 'react';
import styled from 'styled-components';
import { Border, Color, Grid } from '../app/StyleGuide';
import { BrandCode } from '../features/curriculum';
import { createCurriculum } from '../hooks/useCurriculum';
import { TrainingImage } from './TrainingImage';

const CurriculumImageContainer = styled.div<{ $background?: string }>`
  background: ${props => (props.$background ? props.$background : Color.Gray._20)};
  border-radius: ${Border.radius};

  height: 102px;
  width: 212px;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    width: auto;
  }

  svg {
    max-height: ${Grid._10};
    max-width: ${Grid._13};
    width: auto;
    height: auto;
    flex-shrink: 0;
    object-fit: contain;
  }
`;

type CurriculumImageProps = {
  brandCode: string | undefined;
  className?: string;
};

const getCurriculumBrand = (brandCode?: string) => {
  if (!brandCode) return null;
  const curriculum = createCurriculum(brandCode as BrandCode);
  const brand = curriculum?.brand;
  if (!brand?.logo && !brand?.imgSrc) return null;
  return brand;
};

const CurriculumImageBase = ({ brandCode, className }: CurriculumImageProps) => {
  const brand = getCurriculumBrand(brandCode);

  if (!brand) {
    return <TrainingImage className={className} />;
  }

  return (
    <CurriculumImageContainer className={className} $background={brand.background}>
      {brand.logo ?? <img alt={brand.name} src={brand.imgSrc} />}
    </CurriculumImageContainer>
  );
};

export const CurriculumImage = styled(CurriculumImageBase)``;
